export const ERROR_TEXT = {
  NETWORK_ERROR: "Ошибка сети. Проверьте ваше интернет-соединение.",
  AUTHENTICATION_FAILED: "Authentication failed. Please try again.",
};
